import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class VersionAvailableGuard implements CanActivate {

  private readonly BLOCKED_ROUTES = new Set<string>([
    'login',
    'loading',
    'explore'
  ]);

  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    const path = route.routeConfig?.path || this.getFirstPathFromUrl(state.url);
    return this.isAllowed(path) ? true : this.router.parseUrl('/');
  }

  private isAllowed(path: string): boolean {
    return path ? !this.BLOCKED_ROUTES.has(path) : true;
  }

  // Fallback por si necesitamos extraer de la URL completa
  private getFirstPathFromUrl(url: string): string {
    // Quita query y fragment
    const clean = url.split('?')[0].split('#')[0];
    // Quita el primer slash
    const parts = clean.replace(/^\//, '').split('/');
    return parts[0] || '';
  }
  
}
